<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>{{ message }}</p>
    <md-button @click=changeMessage() class="md-primary">Нажми сюда</md-button>
  </div>
</template>

<script>
function randomChoice(arr) {
  return arr[Math.floor(arr.length * Math.random())];
}

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data: function () {
    return {
      message: 'Ты самая красивая!',
      messages: ['Ты самая красивая!', 'Ты самая лучшая!', 'Я тебя люблю!', 'Ты прекрасна!']
    };
  },
  methods: {
    changeMessage() {
      this.message = randomChoice(this.messages);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
